// src/components/LoadingSpinner.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../css/loadingSpinner.css';

function LoadingSpinner({ className }) {
    const { t } = useTranslation();

    return (
        <div className={`loading-container ${className || ''}`}>
            <div className="loader"></div>
            {/*<p className="loading-text">{t('survey.loading')}</p>*/}
        </div>
    );
}

export default LoadingSpinner;
